
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as home1_45TNApxCGKxmryo0MZWVVx3o_E34zOUvdihgrOyNaQ4Meta } from "/vercel/path0/apps/app/pages/2/home.vue?macro=true";
import { default as signooUk6QosQv0sYqUZSmcAp3aW3qgDRTSFjiR9HbavjzUMeta } from "/vercel/path0/apps/app/pages/2/sign.vue?macro=true";
import { default as logoutoGbd6kBQche_45dwflMJLkkxGrG_458OuhqddHRy2ri_45EZsMeta } from "/vercel/path0/apps/app/pages/2/logout.vue?macro=true";
import { default as search2B1aHDqKJ_ea10ZQpGFajFguXzOgwbW4ysYi3qTM9hoMeta } from "/vercel/path0/apps/app/pages/2/search.vue?macro=true";
import { default as referralweLa_aNplVsDEIi7v_mbYqf0WzBg7u7bE2TSo_45_Ndj0Meta } from "/vercel/path0/apps/app/pages/2/referral.vue?macro=true";
import { default as indexrKXF03OpDdTmSUZI4DVnXalFAuwLRoVeDVYGeFfdWTgMeta } from "/vercel/path0/apps/app/pages/2/template/index.vue?macro=true";
import { default as _91templateId_93pSOnHMWwnwcSV0RKpJxbfdHdILXj2JxFoSQ0dJbQ9YAMeta } from "/vercel/path0/apps/app/pages/2/template/[templateId].vue?macro=true";
import { default as create_45_91type_93_45_91id_93XZV4k6ay44TeJFeApJQ70WspSbB3cZhDkuEG8vShGhcMeta } from "/vercel/path0/apps/app/pages/2/template/create-[type]-[id].vue?macro=true";
import { default as _91userTemplateId_93mPawTeIeu_TvuxkgXZI98OjHUOPto4_o8BmlN49w34wMeta } from "/vercel/path0/apps/app/pages/2/template/own/[userTemplateId].vue?macro=true";
import { default as templateDOV0_459io_45Oevkd09YW7Nw8mxRZMx_FHtmDLd8EWPopgMeta } from "/vercel/path0/apps/app/pages/2/template.vue?macro=true";
import { default as allcxoXW9k2Q4I51kk_45f6_KhbeTAEv4BPPckCk7pkYH33cMeta } from "/vercel/path0/apps/app/pages/2/templates/all.vue?macro=true";
import { default as ownitYjd9EmEJ_45Dx9kPeC4x1H9d3Asq9Nu54pnPzCwkJ2QMeta } from "/vercel/path0/apps/app/pages/2/templates/own.vue?macro=true";
import { default as indexxaP53UfDfgkxMZu9SNNn3i2M_45_fHJx75nEJH4bx_45Wt4Meta } from "/vercel/path0/apps/app/pages/2/templates/index.vue?macro=true";
import { default as recent1tKn2SWXrzVvStimWuZQqeZ77Xut5XlWwdVSzEdCgvkMeta } from "/vercel/path0/apps/app/pages/2/templates/recent.vue?macro=true";
import { default as favouritesHf8Rm_1XARvEyoZ_FG8gqH6c7SSrpAX2M5QIFArNvucMeta } from "/vercel/path0/apps/app/pages/2/templates/favourites.vue?macro=true";
import { default as _91categoryId_93jHBLgzhysYF0_45HK2G7yGQmd2NADk5Qh3YtihvvuV65sMeta } from "/vercel/path0/apps/app/pages/2/templates/category/[categoryId].vue?macro=true";
import { default as _91collectionId_93b2sPK291OudMXRQDjJcduNBdZMyDr5EtT3vzQEsNb9cMeta } from "/vercel/path0/apps/app/pages/2/templates/collection/[collectionId].vue?macro=true";
import { default as templatesBqT3538TgKgxIFw4VgGyBwoOlosvyP5J8E_45XAVzIdpgMeta } from "/vercel/path0/apps/app/pages/2/templates.vue?macro=true";
import { default as enable_45mfan6BzYpKmHrZdBO3j_9TS6JvFq_45IjfjMG5VPR4AaGyL4Meta } from "/vercel/path0/apps/app/pages/2/enable-mfa.vue?macro=true";
import { default as cancellationJXOH4muF3YiW7y_45pw9IIWlj6MMlztFuGJBB7Gci8800Meta } from "/vercel/path0/apps/app/pages/2/cancellation.vue?macro=true";
import { default as usersdd8WHCMrJNbcG_UIMXq8i6i4KaSPw_45Qr_45x_ejFVOV9gMeta } from "/vercel/path0/apps/app/pages/2/settings/users.vue?macro=true";
import { default as index2bGY6MPtutwYC5UEFnFrKNZ_3jCv9WjReLQN2ssoviUMeta } from "/vercel/path0/apps/app/pages/2/documents/index.vue?macro=true";
import { default as newdw2Kz2pjxnTJcRQBsx1r5udpIkU5LuarXM7NBnGvAKQMeta } from "/vercel/path0/apps/app/pages/2/documents/v/new.vue?macro=true";
import { default as index0Fp2ABW5p8hUET2dHre5H3hp0vm2PWOwwGZ6fT8hkq8Meta } from "/vercel/path0/apps/app/pages/2/documents/d/index.vue?macro=true";
import { default as indexi76Ri5gGUs_45C3GV69gAgNoPPCiaQmMrrq9WLq8w9HfwMeta } from "/vercel/path0/apps/app/pages/2/documents/f/index.vue?macro=true";
import { default as recent12SVZRD3FHK4sbA9yzTAUrmyGjyDQ7GmmH7TENLuxGgMeta } from "/vercel/path0/apps/app/pages/2/documents/v/recent.vue?macro=true";
import { default as documents0Bm3w1RhU2oe7vfCe3CN6Y2SsK64GVqkqciX7umyzYUMeta } from "/vercel/path0/apps/app/pages/2/settings/documents.vue?macro=true";
import { default as indexkuATGqTQSrghCtZFzEASLbTNSAm1LxWPdEIUFM8YhMYMeta } from "/vercel/path0/apps/app/pages/2/subscription/index.vue?macro=true";
import { default as _91_46_46_46slug_93R3XoVmYPhXwnlt_BcGA0bgUys2A_45LW3qGQebPE_45RJEkMeta } from "/vercel/path0/apps/app/pages/2/documents/[...slug].vue?macro=true";
import { default as upkeep_45GwIT7_0it8UAseRlKz6GK_U463pd37qoSlJrnlLh08Meta } from "/vercel/path0/apps/app/pages/2/subscription/upkeep.vue?macro=true";
import { default as _91viewId_93LUa2HtqO6CZdB8WaPKNlHdd9GqcSfRGoo65eiXq5c7kMeta } from "/vercel/path0/apps/app/pages/2/documents/v/[viewId].vue?macro=true";
import { default as not_45foundpKP2plRYsYeLJ9aZ3mds2rPxFJqDcu3Yv0Y3jT41nbwMeta } from "/vercel/path0/apps/app/pages/2/documents/v/not-found.vue?macro=true";
import { default as _91folderId_93YlfebTuDDWUTbgOtCw_HWmbiPCHzQXTCncThJs7AbNQMeta } from "/vercel/path0/apps/app/pages/2/documents/f/[folderId].vue?macro=true";
import { default as _91documentId_93PrEndVIW3gUlQodEjpEB8uJM7MWxfFV9U2sChBv3_MwMeta } from "/vercel/path0/apps/app/pages/2/documents/d/[documentId].vue?macro=true";
import { default as _91partner_93FFw_V40yW9legNS6nZnKyfsixvhwNnZHb_S6nkqLNXYMeta } from "/vercel/path0/apps/app/pages/2/activate-partnership/[partner].vue?macro=true";
import { default as _2C4ahqfvvt9H5KhUQuubKf9PMc6UmJEKG3ibRH_vxZLUMeta } from "/vercel/path0/apps/app/pages/2.vue?macro=true";
import { default as _91_46_46_46slug_93duOx4lL53wj3KSosTscvdwlPEaZMe_45BLM57kpsexdcUMeta } from "/vercel/path0/apps/app/pages/[...slug].vue?macro=true";
import { default as indexk5rblyQcK80lkqifQqQ_Qk2RxvSgtnLyhSuahwTsSD0Meta } from "/vercel/path0/apps/app/pages/welcome/index.vue?macro=true";
import { default as billing_KJwWwc36XPDruFy55bLAJy0np_45CdMGoREnmtT_JWq4Meta } from "/vercel/path0/apps/app/pages/welcome/billing.vue?macro=true";
import { default as _91secret_93yZxElp0ibX2duBQbP_WZ5erXOF9nbXLdM8mCNXyQwysMeta } from "/vercel/path0/apps/app/pages/welcome/[secret].vue?macro=true";
export default [
  {
    name: "2",
    path: "/2",
    component: () => import("/vercel/path0/apps/app/pages/2.vue"),
    children: [
  {
    name: "2-home",
    path: "home",
    meta: home1_45TNApxCGKxmryo0MZWVVx3o_E34zOUvdihgrOyNaQ4Meta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/home.vue")
  },
  {
    name: "2-sign",
    path: "sign",
    component: () => import("/vercel/path0/apps/app/pages/2/sign.vue")
  },
  {
    name: "2-logout",
    path: "logout",
    meta: logoutoGbd6kBQche_45dwflMJLkkxGrG_458OuhqddHRy2ri_45EZsMeta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/logout.vue")
  },
  {
    name: "2-search",
    path: "search",
    meta: search2B1aHDqKJ_ea10ZQpGFajFguXzOgwbW4ysYi3qTM9hoMeta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/search.vue")
  },
  {
    name: "2-referral",
    path: "referral",
    meta: referralweLa_aNplVsDEIi7v_mbYqf0WzBg7u7bE2TSo_45_Ndj0Meta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/referral.vue")
  },
  {
    name: templateDOV0_459io_45Oevkd09YW7Nw8mxRZMx_FHtmDLd8EWPopgMeta?.name,
    path: "template",
    component: () => import("/vercel/path0/apps/app/pages/2/template.vue"),
    children: [
  {
    name: "2-template",
    path: "",
    meta: indexrKXF03OpDdTmSUZI4DVnXalFAuwLRoVeDVYGeFfdWTgMeta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/template/index.vue")
  },
  {
    name: "2-template-templateId",
    path: ":templateId()",
    meta: _91templateId_93pSOnHMWwnwcSV0RKpJxbfdHdILXj2JxFoSQ0dJbQ9YAMeta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/template/[templateId].vue")
  },
  {
    name: "2-template-create-type-id",
    path: "create-:type()-:id()",
    meta: create_45_91type_93_45_91id_93XZV4k6ay44TeJFeApJQ70WspSbB3cZhDkuEG8vShGhcMeta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/template/create-[type]-[id].vue")
  },
  {
    name: "2-template-own-userTemplateId",
    path: "own/:userTemplateId()",
    meta: _91userTemplateId_93mPawTeIeu_TvuxkgXZI98OjHUOPto4_o8BmlN49w34wMeta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/template/own/[userTemplateId].vue")
  }
]
  },
  {
    name: templatesBqT3538TgKgxIFw4VgGyBwoOlosvyP5J8E_45XAVzIdpgMeta?.name,
    path: "templates",
    meta: templatesBqT3538TgKgxIFw4VgGyBwoOlosvyP5J8E_45XAVzIdpgMeta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/templates.vue"),
    children: [
  {
    name: "2-templates-all",
    path: "all",
    component: () => import("/vercel/path0/apps/app/pages/2/templates/all.vue")
  },
  {
    name: "2-templates-own",
    path: "own",
    component: () => import("/vercel/path0/apps/app/pages/2/templates/own.vue")
  },
  {
    name: "2-templates",
    path: "",
    component: () => import("/vercel/path0/apps/app/pages/2/templates/index.vue")
  },
  {
    name: "2-templates-recent",
    path: "recent",
    component: () => import("/vercel/path0/apps/app/pages/2/templates/recent.vue")
  },
  {
    name: "2-templates-favourites",
    path: "favourites",
    component: () => import("/vercel/path0/apps/app/pages/2/templates/favourites.vue")
  },
  {
    name: "2-templates-category-categoryId",
    path: "category/:categoryId()",
    component: () => import("/vercel/path0/apps/app/pages/2/templates/category/[categoryId].vue")
  },
  {
    name: "2-templates-collection-collectionId",
    path: "collection/:collectionId()",
    component: () => import("/vercel/path0/apps/app/pages/2/templates/collection/[collectionId].vue")
  }
]
  },
  {
    name: "2-enable-mfa",
    path: "enable-mfa",
    meta: enable_45mfan6BzYpKmHrZdBO3j_9TS6JvFq_45IjfjMG5VPR4AaGyL4Meta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/enable-mfa.vue")
  },
  {
    name: "2-cancellation",
    path: "cancellation",
    meta: cancellationJXOH4muF3YiW7y_45pw9IIWlj6MMlztFuGJBB7Gci8800Meta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/cancellation.vue")
  },
  {
    name: "2-settings-users",
    path: "settings/users",
    meta: usersdd8WHCMrJNbcG_UIMXq8i6i4KaSPw_45Qr_45x_ejFVOV9gMeta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/settings/users.vue")
  },
  {
    name: "2-documents",
    path: "documents",
    component: () => import("/vercel/path0/apps/app/pages/2/documents/index.vue")
  },
  {
    name: "2-documents-v-new",
    path: "documents/v/new",
    component: () => import("/vercel/path0/apps/app/pages/2/documents/v/new.vue")
  },
  {
    name: "2-documents-d",
    path: "documents/d",
    component: () => import("/vercel/path0/apps/app/pages/2/documents/d/index.vue")
  },
  {
    name: "2-documents-f",
    path: "documents/f",
    component: () => import("/vercel/path0/apps/app/pages/2/documents/f/index.vue")
  },
  {
    name: "2-documents-v-recent",
    path: "documents/v/recent",
    component: () => import("/vercel/path0/apps/app/pages/2/documents/v/recent.vue")
  },
  {
    name: "2-settings-documents",
    path: "settings/documents",
    meta: documents0Bm3w1RhU2oe7vfCe3CN6Y2SsK64GVqkqciX7umyzYUMeta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/settings/documents.vue")
  },
  {
    name: "2-subscription",
    path: "subscription",
    meta: indexkuATGqTQSrghCtZFzEASLbTNSAm1LxWPdEIUFM8YhMYMeta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/subscription/index.vue")
  },
  {
    name: "2-documents-slug",
    path: "documents/:slug(.*)*",
    component: () => import("/vercel/path0/apps/app/pages/2/documents/[...slug].vue")
  },
  {
    name: "2-subscription-upkeep",
    path: "subscription/upkeep",
    meta: upkeep_45GwIT7_0it8UAseRlKz6GK_U463pd37qoSlJrnlLh08Meta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/subscription/upkeep.vue")
  },
  {
    name: "2-documents-v-viewId",
    path: "documents/v/:viewId()",
    component: () => import("/vercel/path0/apps/app/pages/2/documents/v/[viewId].vue")
  },
  {
    name: "2-documents-v-not-found",
    path: "documents/v/not-found",
    component: () => import("/vercel/path0/apps/app/pages/2/documents/v/not-found.vue")
  },
  {
    name: "2-documents-f-folderId",
    path: "documents/f/:folderId()",
    meta: _91folderId_93YlfebTuDDWUTbgOtCw_HWmbiPCHzQXTCncThJs7AbNQMeta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/documents/f/[folderId].vue")
  },
  {
    name: "2-documents-d-documentId",
    path: "documents/d/:documentId()",
    meta: _91documentId_93PrEndVIW3gUlQodEjpEB8uJM7MWxfFV9U2sChBv3_MwMeta || {},
    component: () => import("/vercel/path0/apps/app/pages/2/documents/d/[documentId].vue")
  },
  {
    name: "2-activate-partnership-partner",
    path: "activate-partnership/:partner()",
    component: () => import("/vercel/path0/apps/app/pages/2/activate-partnership/[partner].vue")
  }
]
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/vercel/path0/apps/app/pages/[...slug].vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    component: () => import("/vercel/path0/apps/app/pages/welcome/index.vue")
  },
  {
    name: "welcome-billing",
    path: "/welcome/billing",
    meta: billing_KJwWwc36XPDruFy55bLAJy0np_45CdMGoREnmtT_JWq4Meta || {},
    component: () => import("/vercel/path0/apps/app/pages/welcome/billing.vue")
  },
  {
    name: "welcome-secret",
    path: "/welcome/:secret()",
    meta: _91secret_93yZxElp0ibX2duBQbP_WZ5erXOF9nbXLdM8mCNXyQwysMeta || {},
    component: () => import("/vercel/path0/apps/app/pages/welcome/[secret].vue")
  }
]